import React from 'react';

import ProfileTabs from './component';

export default React.memo(ProfileTabs);
